import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import React, { useEffect, useState } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import { Box, Button, Divider, Typography } from "@mui/material";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import Progress from "./Progress";
import Photos from "./Photos";
import ConfirmMeeting from "./ConfirmMeeting";
import ApproximateSubmission from "./Submission";
import RequestAssign from "./RequestAssign";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import jwtDecode from "jwt-decode";
import RequestChange from "./RequestChange";
import SiteVisitMeeting from "./SiteVisitMeeting";
import { toast } from "react-toastify";
import {
  Timeline,
  TimelineConnector,
  timelineItemClasses,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignments}`;

export default function RequestReview(props) {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [openRequestChange, setOpenRequestChange] = useState(false);
  const [openMeeting, setOpenMeeting] = useState(false);
  const [reviewDate, setReviewDate] = useState();
  const [selectedRoleUser, setSelectedRoleUser] = useState();
  const classes = useStyles(props);
  const navigate = useNavigate();

  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const currentUser = token?.email;
  const currentUserRoles = token?.scope;

  const handleRequestReviewNext = async () => {
    if (reviewDate.assignees.length > 0) {
      if (reviewDate.designStudioCategory === "SHR") {
        if (
          currentUserRoles &&
          currentUserRoles?.includes("ROLE_PARTNER_ADMIN")
        ) {
          navigate("/design-studio/space-planing-review/" + id);
        } else navigate("/design-studio/space-planing/" + id);
      } else if (reviewDate.designStudioCategory === "RET" || reviewDate.designStudioCategory === "MOU") {
        if (
          currentUserRoles &&
          currentUserRoles?.includes("ROLE_PARTNER_ADMIN")
        ) {
          navigate("/design-studio/individual-kitchen-design-review/" + id);
        } else navigate("/design-studio/individual-kitchen-design/" + id);
      } else if (reviewDate.designStudioCategory === "PRJ") {
        console.log("PRJ");
      } else if (reviewDate.designStudioCategory === "MISC") {
        console.log("MISC");
      }
    } else setOpen(true);
  };

  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);

  const loadDate = async () => {
    try {
      const list = await OAuthService.getList(`${url}/${id}`);
      let data = list.data;
      // const data = request.filter(i => i.dsTaskId === parseInt(id))
      setReviewDate(data);
    } catch (error) {
      setError(error.message);
      console.log(error);
    }
  };

  useEffect(() => {
    loadDate();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseRequestChange = () => {
    setOpenRequestChange(false);
  };

  const handleCloseMeeting = () => {
    setOpenMeeting(false);
  };

  const handleRescheduleMeeting = () => {
    setOpenMeeting(true);
  };

  const handleRoleSubmit = async () => {
    const tempData = {
      ...reviewDate,
      assignees: [selectedRoleUser?.value],
      isDsLifeCyclePassForNextState: reviewDate?.dsLifeCycle === "REQUEST_BRIEF_REVIEW",
      isDsStatusPassForNextState: false,
    };
    setReviewDate(tempData);
    await OAuthService.putData(`${url}/${id}`, tempData);
    if (reviewDate.designStudioCategory === "SHR") {
      navigate("/design-studio/space-planing/" + id);
    } else if (reviewDate.designStudioCategory === "RET" || reviewDate.designStudioCategory === "MOU") {
      navigate("/design-studio/individual-kitchen-design/" + id);  
    } else if (reviewDate.designStudioCategory === "PRJ") {
      console.log("PRJ");
    } else if (reviewDate.designStudioCategory === "MISC") {
      console.log("MISC");
    }
  };

  const handleBack = () => {
    navigate("/design-studio/showroom-questionnaire/" + id);
  };

  const handleReqCommentSubmit = async (value) => {
    // console.log(value)
    // setOpenRequestChange(false)
    const payload = {
      ...reviewDate,
      // dsLifeCycle: 'SPACE_PLANNING',
      isDsLifeCyclePassForNextState: false,
      isDsStatusPassForNextState: false,
      comment: value,
      // comments: {
      //   additionalProp1: [...reviewDate.comments.additionalProp1],
      //   additionalProp2: [...reviewDate.comments.additionalProp2],
      //   additionalProp3: [
      //     ...reviewDate.comments.additionalProp3,
      //     {
      //       comment: value,
      //       lastModifiedDate: new Date().toISOString(),
      //       lastModifyBy: token?.email,
      //     },
      //   ],
      // },
    };
    console.log('payload', payload)
    try {
      await OAuthService.putData(`${url}/${id}`, payload).then((resp) => {
        setOpenRequestChange(false);
        toast.success("Comment Update Successfully");
        setReviewDate(payload);
      });
    } catch (error) {
      console.log(error);
      setError(error.message);
    }
  };

  const handleRequestChange = () => {
    setOpenRequestChange(true);
  };

  const handleSiteMeeting = async (start, end, addressValue) => {
    const payload = {
      ...reviewDate,
      isDsLifeCyclePassForNextState: false,
      isDsStatusPassForNextState: false,
      scheduledStartDate: moment(start).format("YYYY-MM-DD hh:mm"),
      scheduledEndDate: moment(end).format("YYYY-MM-DD hh:mm"),
      location: addressValue,
    };
    try {
      await OAuthService.putData(`${url}/${id}`, payload);
      setOpenMeeting(false);
      toast.success("Site Visit Meeting Update Successfully");
      setReviewDate(payload);
    } catch (error) {
      console.log(error);
      setError(error.message);
    }
  };

  return (
    <>
      <FusePageCarded
        classes={{
          content: "flex",
          header: "min-h-72 h-72 sm:h-136 sm:min-h-136",
        }}
        header={
          <ListPageHeader
            componentName="Review"
            pageName={`Review #${id}`}
            handleBack={handleBack}
            handleRequestReviewNext={handleRequestReviewNext}
            showPaginationDropdown={showPaginationDropdown}
            requestCategory={reviewDate?.designStudioCategory}
          />
        }
        content={
          <>
            <div className={clsx(classes.root, "px-24 md:px-32")}>
              <Progress
                currentStep={2}
                category={reviewDate?.designStudioCategory}
              />
              <Photos files={reviewDate?.dsTaskAssignmentFiles} />
              <ConfirmMeeting reviewDate={reviewDate} />
              {reviewDate?.submissionDate && (
                <ApproximateSubmission reviewDate={reviewDate} />
              )}

              {reviewDate?.comments?.additionalProp3 && (
                <>
                  <Box className="mt-16 p-8">
                    <Typography variant="subtitle1">Comment</Typography>
                    <Divider sx={{ my: 2 }} />
                    <Timeline
                      sx={{
                        [`& .${timelineItemClasses.root}:before`]: {
                          flex: 0,
                          padding: 0,
                        },
                      }}
                    >
                      {reviewDate?.comments?.additionalProp3?.map((comment) => (
                        <TimelineItem>
                          <TimelineSeparator>
                            <TimelineDot />
                            <TimelineConnector />
                          </TimelineSeparator>
                          <TimelineContent>
                            <div>
                              <strong>{comment.lastModifyBy}</strong> assigned
                              you for request change
                            </div>
                            <div class="flex flex-col sm:flex-row sm:items-center mt-8 sm:mt-4 sm:space-x-8 text-md leading-5">
                              <Typography variant="body1" className="text-13">
                                {comment.lastModifiedDate}
                              </Typography>
                            </div>
                            <Box className="mt-16 py-16 px-20 rounded-lg border">
                              {comment.comment}
                            </Box>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                    </Timeline>
                  </Box>
                </>
              )}

              <div className="pt-16 mt-10">
                <Button
                  variant="contained"
                  color="warning"
                  size="large"
                  sx={{ mr: 1 }}
                  onClick={handleRequestReviewNext}
                >
                  Confirm & Next
                </Button>
                <Button
                  variant="outlined"
                  color="warning"
                  size="large"
                  sx={{ mr: 1 }}
                  onClick={handleRequestChange}
                >
                  Comments/feedback
                </Button>
                <Button
                  variant="outlined"
                  color="warning"
                  size="large"
                  onClick={handleRescheduleMeeting}
                >
                  Reschedule Site Visit
                </Button>
              </div>
            </div>
          </>
        }
        innerScroll
      />
      <RequestAssign
        open={open}
        handleClose={handleClose}
        selectedUser={selectedRoleUser}
        SetSelectedUser={setSelectedRoleUser}
        handleRoleSubmit={handleRoleSubmit}
      />
      <RequestChange
        open={openRequestChange}
        handleClose={handleCloseRequestChange}
        // data={data}
        handleReqCommentSubmit={handleReqCommentSubmit}
        title={"Request a change"}
      />
      <SiteVisitMeeting
        open={openMeeting}
        handleClose={handleCloseMeeting}
        handleSiteMeeting={handleSiteMeeting}
      />
    </>
  );
}
